module.exports = __webpack_public_path__ + "0c4192768f00ae06e4f4ede4552c8126.jpg";